import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const DetailsContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "inviteTheme",
})(({ theme, inviteTheme }) => ({
  padding: "0 16px",
  textAlign: "center",
  whiteSpace: "pre-line",
  backgroundColor: inviteTheme?.eventDetailsBackgroundColor,
  [theme.breakpoints.up("mobile")]: {
    padding: "0 40px",
  },
  "& .title": {
    marginTop: 30,
    marginBottom: 20,
  },
  "& .description": {
    marginBottom: 30,
  },
  "& .dateLabel": {
    marginBottom: 10,
  },
  "& .locationLabel": {
    marginBottom: 10,
  },
  "& .location": {
    marginBottom: 50,
  },
}));

export const Block2Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "inviteTheme",
})(({ theme, inviteTheme }) => ({
  padding: "0 16px",
  textAlign: "center",
  whiteSpace: "pre-line",
  backgroundColor: inviteTheme?.eventBlock2BackgroundColor,
  [theme.breakpoints.up("mobile")]: {
    padding: "0 40px",
  },
  "& .title": {
    marginTop: 30,
    marginBottom: 20,
  },
  "& .details": {
    marginBottom: 50,
  },
}));

export const HostContainer = styled("div")({
  marginBottom: 20,
});

export const EventDate = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: 30,
});
